// Fetch list

export const FETCH = 'reportCarrierResults.FETCH'
export const FETCH_STARTED = 'reportCarrierResults.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCarrierResults.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCarrierResults.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCarrierResults.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCarrierResults.CLEAR'

// Export

export const EXPORT = 'reportCarrierResults.EXPORT'
export const EXPORT_FULFILLED = 'reportCarrierResults.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportCarrierResults.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCarrierResults.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCarrierResults.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCarrierResults.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCarrierResults.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportCarrierResults.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportCarrierResults.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCarrierResults.EXPORT_DETAILS_FULFILLED'
